import { CssBaseline } from "@mui/material";
import { AuthProvider, type OidcUser } from "@ssf/auth-components";
import {
  AppContainer,
  AppWrapper,
  clubTheme,
  Page,
  queryClient,
} from "@ssf/components";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { QueryClientProvider } from "@tanstack/react-query";
import { i18next, setAuthorization } from "../lib/index.js";
import { Footer } from "./components/Footer.jsx";
import { Header } from "./components/Header.jsx";
import { Router } from "./components/Router.jsx";
import ComingSoonPage from "./pages/ComingSoonPage.jsx";

const SIGNIN_REDIRECT_ARGS = { extraQueryParams: { traditionalClubs: true } };

const onUser = (user: OidcUser | null | undefined) => {
  setMemdbAuthorization(user?.access_token);
  setAuthorization(user?.access_token);
};

export const App = () => (
  <AppWrapper env={import.meta.env} theme={clubTheme} i18n={i18next}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        signinRedirectArgs={SIGNIN_REDIRECT_ARGS}
        redirectOnSilentFailure={false}
        onUser={onUser}
      >
        <Page>
          <Header />
          <AppContainer>
            {import.meta.env.DEV ? <Router /> : <ComingSoonPage />}
          </AppContainer>
          <Footer />
        </Page>
      </AuthProvider>
    </QueryClientProvider>
  </AppWrapper>
);
